<div class="flex-box">
  <div class="dialog-header">
    <button class="back-page">
      <img
        src="../../../assets/icons/back-icon.svg"
        alt=""
        (click)="backHome()"
      />
    </button>
    <p class="paragrafo">{{title}}</p>
  </div>

  <div class="search-container">
    <app-search-bar
      actionText="Pesquisar"
      [placeholder]="searchPlaceHolder"
      (search)="filter($event)"
    ></app-search-bar>
  </div>

  <div class="custom-dialog-select-button">
    <app-tree
      [treeData]="treeData"
      (emitterConfirmEnable)="enableConfirmButton($event)"
    >
    </app-tree>
  </div>
  <div class="button-container">
    <button mat-fab
      [ngClass]="{
        'btn-modal-select-on': confirmEnable,
        'btn-modal-select-off': !confirmEnable
      }"
      (click)="confirmData()"
      [disabled]="!confirmEnable">
      <img src="../../../assets/icons/Component 109 – 2.svg" alt="" />
    </button>
  </div>
</div>
